module.exports = __webpack_public_path__ + "img/COG.730a2794.svg";